var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "Editor-task" } }, [
    _c("div", { staticClass: "editor-task" }, [
      _c("div", { staticClass: "editor-task-content" }, [
        _vm.currentWorkflow
          ? _c(
              "div",
              { staticClass: "status-switcher-wrapper" },
              [
                _c("TicketStatusSwitcher", {
                  attrs: {
                    "status-list": _vm.pipelineStages,
                    "current-status": _vm.currentStage.name,
                  },
                  on: { "update-status": _vm.handleStageChange },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input title-input" },
          [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("task.title"))),
            ]),
            _vm._v(" "),
            _c("a-input", {
              staticClass: "classic-new-input",
              attrs: { placeholder: "Task #" },
              model: {
                value: _vm.form.title,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "title", $$v)
                },
                expression: "form.title",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "editor-task-quill-editor" },
          [
            _c("quill-editor", {
              staticClass: "quill-editor",
              staticStyle: { "max-height": "20%", width: "100%" },
              attrs: {
                options: _vm.editorOption,
                placeholder: _vm.$t("task.createTaskDesc"),
              },
              model: {
                value: _vm.form.description,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "description", $$v)
                },
                expression: "form.description",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "editor-task-new-checklist" }, [
          _c("div", { staticClass: "checklist-data" }, [
            _vm.form.checklist.length > 0
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      gap: "20px",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-weight": "bold",
                          "font-size": "16px",
                          "margin-right": "20px",
                        },
                      },
                      [_vm._v("Checklist")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { width: "200px" } },
                      [
                        _c("a-progress", {
                          attrs: {
                            "stroke-color": {
                              "0%": "ec4b1d",
                              "100%": "ec4b1d",
                            },
                            percent:
                              (100 / _vm.form.checklist.length) *
                              _vm.form.checklist.filter(function (c) {
                                return c.isCompleted
                              }).length,
                            "show-info": false,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticStyle: { width: "200px" } }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$t("task.completedOfCheck", {
                              total: _vm.form.checklist.length,
                              completed: _vm.form.checklist.filter(function (
                                c
                              ) {
                                return c.isCompleted
                              }).length,
                            })
                          ) +
                          "\n                        "
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "10px",
                  display: "flex",
                  gap: "10px",
                  "flex-direction": "column",
                },
              },
              _vm._l(_vm.form.checklist, function (checkbox, index) {
                return _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "flex-start",
                      "user-select": "none",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          gap: "10px",
                        },
                      },
                      [
                        _c("a-checkbox", {
                          staticClass: "kanban-checkbox large",
                          model: {
                            value: checkbox.isCompleted,
                            callback: function ($$v) {
                              _vm.$set(checkbox, "isCompleted", $$v)
                            },
                            expression: "checkbox.isCompleted",
                          },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: checkbox.title,
                              expression: "checkbox.title",
                            },
                          ],
                          staticStyle: {
                            width: "300px",
                            border: "none",
                            outline: "none",
                            background: "#f1f1f1",
                            "border-radius": "4px",
                            padding: "3px 10px",
                          },
                          domProps: { value: checkbox.title },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(checkbox, "title", $event.target.value)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "material-icons",
                        on: {
                          click: function ($event) {
                            return _vm.deleteCheckbox(index)
                          },
                        },
                      },
                      [_vm._v("close")]
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "10px",
                  color: "#ec4b1d",
                  "font-weight": "bold",
                  cursor: "pointer",
                },
                on: { click: _vm.addNewCheckBox },
              },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(
                      !_vm.form.checklist.length
                        ? _vm.$t("task.newCheckList")
                        : _vm.$t("task.add")
                    ) +
                    "\n                    "
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "editor-task-attach-files",
            on: { click: _vm.openFileInput },
          },
          [
            _c("div", { staticClass: "attach-files" }, [
              _c("div", { staticClass: "text" }, [
                _c("div", { staticClass: "material-icons" }, [
                  _vm._v("attachment"),
                ]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.$t("task.attachFiles")))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "logo" }, [_c("s3Logo")], 1),
            ]),
            _vm._v(" "),
            _c("input", {
              staticStyle: { display: "none" },
              attrs: { id: "fileInput", type: "file" },
              on: { change: _vm.uploadFile },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row", staticStyle: { display: "grid", gap: "20px" } },
          _vm._l(_vm.form.attachments, function (attachment) {
            return _c(
              "div",
              { staticClass: "attach-files-visibility" },
              [
                ["png", "jpeg", "jpg"].includes(attachment.ext)
                  ? [
                      _c("img", {
                        attrs: {
                          src:
                            "https://static.supsis.live/" +
                            (attachment.path + attachment._id) +
                            "." +
                            attachment.ext,
                          alt: attachment.name,
                        },
                      }),
                    ]
                  : [_vm._m(0, true)],
                _vm._v(" "),
                _c("div", { staticClass: "image-content" }, [
                  _c("div", { staticClass: "text" }, [
                    _vm.editImageName === attachment._id
                      ? _c(
                          "div",
                          { staticClass: "edit-img-name" },
                          [
                            _c("a-input", {
                              attrs: { type: "text" },
                              model: {
                                value: attachment.name,
                                callback: function ($$v) {
                                  _vm.$set(attachment, "name", $$v)
                                },
                                expression: "attachment.name",
                              },
                            }),
                          ],
                          1
                        )
                      : _c("label", [_vm._v(_vm._s(attachment.name))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.updatedAtFormated(attachment.updatedAt)) +
                        "\n                            "
                    ),
                    _c("div", { staticClass: "edit-btn" }, [
                      _c(
                        "div",
                        {
                          staticClass: "underline",
                          on: {
                            click: function ($event) {
                              return _vm.deleteAttachment(attachment._id)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("chatbotv2.delete")) +
                              "\n                                "
                          ),
                        ]
                      ),
                      _vm._v(
                        "\n                                |\n                                "
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "underline",
                          on: {
                            click: function ($event) {
                              return _vm.editImageNameFunc(attachment._id)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("message.edit")) +
                              "\n                                "
                          ),
                        ]
                      ),
                      _vm._v(
                        "\n                                |\n                                "
                      ),
                      ["png", "jpeg", "jpg"].includes(attachment.ext)
                        ? _c(
                            "div",
                            {
                              staticClass: "underline",
                              on: {
                                click: function ($event) {
                                  return _vm.openImage(attachment._id)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.$t("task.view")) +
                                  "\n                                "
                              ),
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "underline",
                              on: {
                                click: function ($event) {
                                  return _vm.openUrlInNewTab(attachment)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.$t("task.view")) +
                                  "\n                                "
                              ),
                            ]
                          ),
                      _vm._v(
                        "\n                                |\n                                "
                      ),
                      ["png", "jpeg", "jpg"].includes(attachment.ext)
                        ? _c(
                            "div",
                            {
                              staticClass: "underline",
                              on: {
                                click: function ($event) {
                                  _vm.form.coverPhoto === attachment._id
                                    ? _vm.removeCoverPhoto()
                                    : _vm.setCoverPhoto(attachment._id)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.form.coverPhoto === attachment._id
                                      ? _vm.$t("message.coverPhotoRemove")
                                      : _vm.$t("message.coverPhotoSet")
                                  ) +
                                  "\n                                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "a-modal",
                  {
                    attrs: {
                      id: "task-attachment-image",
                      visible: _vm.taskAttachmentsImgVisible,
                      footer: false,
                    },
                    on: { cancel: _vm.handleModalCancel },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.selectedImage.url,
                        alt: _vm.selectedImage.name,
                      },
                    }),
                  ]
                ),
              ],
              2
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "add-tags" }, [
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "10px",
                color: "#ec4b1d",
                "font-weight": "bold",
                cursor: "pointer",
                display: "flex",
                "align-items": "center",
              },
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("message.addTag")) +
                  "\n                    "
              ),
              _c(
                "a-dropdown",
                [
                  _c(
                    "a-button",
                    { staticStyle: { "margin-left": "10px", padding: "2px" } },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("add"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-menu",
                    { attrs: { slot: "overlay" }, slot: "overlay" },
                    _vm._l(_vm.tags, function (tag) {
                      return _c(
                        "a-menu-item",
                        {
                          key: tag._id,
                          on: {
                            click: function ($event) {
                              return _vm.selectTag(tag)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(tag.name) +
                              "\n                            "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.tags.length > 0
            ? _c(
                "div",
                { staticClass: "selected-tags" },
                _vm._l(_vm.form.tags, function (tag) {
                  return _c(
                    "div",
                    {
                      key: tag._id,
                      staticClass: "tag-item",
                      style: _vm.getTagStyle(tag.color),
                    },
                    [
                      _c("span", [_vm._v(_vm._s(tag.name))]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "material-icons close-icon",
                          on: {
                            click: function ($event) {
                              return _vm.removeTag(tag._id)
                            },
                          },
                        },
                        [_vm._v("close")]
                      ),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "editor-task-new-subtask" }, [
          _vm.form.subTasks.length > 0
            ? _c(
                "div",
                {
                  staticStyle: {
                    "margin-top": "10px",
                    display: "flex",
                    gap: "10px",
                    "flex-direction": "column",
                  },
                },
                _vm._l(_vm.form.subTasks, function (subtask, index) {
                  return _c("div", [
                    !subtask.isExits
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "space-between",
                              "user-select": "none",
                              gap: "20px",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  gap: "10px",
                                  width: "100%",
                                },
                              },
                              [
                                _c("a-checkbox", {
                                  staticClass: "kanban-checkbox large",
                                  model: {
                                    value: subtask.completed,
                                    callback: function ($$v) {
                                      _vm.$set(subtask, "completed", $$v)
                                    },
                                    expression: "subtask.completed",
                                  },
                                }),
                                _vm._v(" "),
                                _c("a-input", {
                                  staticClass: "classic-new-input",
                                  attrs: {
                                    placeholder: _vm.$t("task.subtaskTitle"),
                                  },
                                  model: {
                                    value: subtask.title,
                                    callback: function ($$v) {
                                      _vm.$set(subtask, "title", $$v)
                                    },
                                    expression: "subtask.title",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { width: "100%" } },
                              [
                                _c("a-select", {
                                  staticClass: "select-multiple",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    options: _vm.visibilityUsers,
                                    placeholder: _vm.$t("task.assignee"),
                                  },
                                  model: {
                                    value: subtask.assignees,
                                    callback: function ($$v) {
                                      _vm.$set(subtask, "assignees", $$v)
                                    },
                                    expression: "subtask.assignees",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "material-icons",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteSubtask(index)
                                  },
                                },
                              },
                              [_vm._v("close")]
                            ),
                          ]
                        )
                      : _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "space-between",
                              "user-select": "none",
                              gap: "20px",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { width: "100%" } },
                              [
                                _c("a-select", {
                                  staticClass: "select-multiple",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    options: _vm.visibilityUsers,
                                    placeholder: _vm.$t("task.assignee"),
                                  },
                                  model: {
                                    value: subtask.taskId,
                                    callback: function ($$v) {
                                      _vm.$set(subtask, "taskId", $$v)
                                    },
                                    expression: "subtask.taskId",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "material-icons",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteSubtask(index)
                                  },
                                },
                              },
                              [_vm._v("close")]
                            ),
                          ]
                        ),
                  ])
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row gap-10" }, [
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "10px",
                  color: "#ec4b1d",
                  "font-weight": "bold",
                  cursor: "pointer",
                },
                on: {
                  click: function ($event) {
                    return _vm.addNewSubtask(false)
                  },
                },
              },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("task.addSubtask")) +
                    "\n                    "
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "comments-section" },
          [
            _c("createComment", { attrs: { "task-id": _vm.details.taskId } }),
            _vm._v(" "),
            _c("listComment", { attrs: { "task-id": _vm.details.taskId } }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "editor-info" }, [
      _c("div", { staticClass: "info-task-list" }, [
        _c("div", { staticClass: "info-task-item" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("message.startDate")))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "info-task-item-value" },
            [
              _c("a-date-picker", {
                attrs: {
                  dropdownClassName: "task-date-picker",
                  "show-time": "",
                },
                model: {
                  value: _vm.form.startDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "startDate", $$v)
                  },
                  expression: "form.startDate",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-task-item" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("message.endDate")))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "info-task-item-value" },
            [
              _c("a-date-picker", {
                attrs: {
                  dropdownClassName: "task-date-picker",
                  "show-time": "",
                },
                model: {
                  value: _vm.form.endDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "endDate", $$v)
                  },
                  expression: "form.endDate",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-task-item" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("task.priority")))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "info-task-item-value" },
            [
              _c(
                "a-select",
                {
                  staticStyle: { width: "167px" },
                  model: {
                    value: _vm.form.priority,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "priority", $$v)
                    },
                    expression: "form.priority",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "low" } }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex", gap: "5px" } },
                      [
                        _c("LowIcon", {
                          staticStyle: {
                            width: "20px",
                            height: "20px",
                            "margin-top": "3px",
                          },
                        }),
                        _vm._v(
                          "\n                                Low\n                            "
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "lowest" } }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex", gap: "5px" } },
                      [
                        _c("LowestIcon", {
                          staticStyle: {
                            width: "20px",
                            height: "20px",
                            "margin-top": "2px",
                          },
                        }),
                        _vm._v(
                          "\n                                Lowest\n                            "
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "medium" } }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex", gap: "5px" } },
                      [
                        _c("MediumIcon", {
                          staticStyle: { width: "20px", height: "20px" },
                        }),
                        _vm._v(
                          "\n                                Medium\n                            "
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "high" } }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex", gap: "5px" } },
                      [
                        _c("HighIcon", {
                          staticStyle: {
                            width: "20px",
                            height: "20px",
                            "margin-top": "3px",
                          },
                        }),
                        _vm._v(
                          "\n                                High\n                            "
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "highest" } }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex", gap: "5px" } },
                      [
                        _c("HighestIcon", {
                          staticStyle: {
                            width: "20px",
                            height: "20px",
                            "margin-top": "2px",
                          },
                        }),
                        _vm._v(
                          "\n                                Highest\n                            "
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-task-item" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("task.owner")))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "info-task-item-value" },
            [
              _c("a-select", {
                staticClass: "select-multiple",
                staticStyle: { width: "167px" },
                attrs: {
                  options: _vm.visibilityUsers,
                  placeholder: _vm.$t("task.owner"),
                  showSearch: "",
                },
                model: {
                  value: _vm.form.owner,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "owner", $$v)
                  },
                  expression: "form.owner",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-task-item" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("task.assignee")))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "info-task-item-value" },
            [
              _c("a-select", {
                staticStyle: { width: "167px" },
                attrs: {
                  mode: "multiple",
                  placeholder: _vm.$t("task.selectAssginee"),
                  "max-tag-count": _vm.maxTagCount,
                  options: _vm.visibilityUsers,
                  "filter-option": _vm.filterOption,
                },
                model: {
                  value: _vm.form.assignees,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "assignees", $$v)
                  },
                  expression: "form.assignees",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-task-item" }, [
          _c("label", [_vm._v("Task ID")]),
          _vm._v(" "),
          _c("div", { staticClass: "info-task-item-value" }, [
            _vm._v(_vm._s(_vm.form._id)),
          ]),
        ]),
        _vm._v(" "),
        _vm.usersMap[_vm.form.createdBy.user]
          ? _c(
              "div",
              {
                staticClass: "info-task-item",
                staticStyle: { display: "block" },
              },
              [
                _c("label", [
                  _vm._v(" " + _vm._s(_vm.$t("message.taskCreator")) + " "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "create-task-avatar-message" },
                  [
                    _c("Avatar", {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                        }",
                        },
                      ],
                      key: 1,
                      attrs: {
                        size: 25,
                        src: _vm.usersMap[_vm.form.createdBy.user].gravatar,
                        username: _vm.usersMap[_vm.form.createdBy.user].name,
                        content: _vm.usersMap[_vm.form.createdBy.user].email,
                      },
                    }),
                    _vm._v(" "),
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.usersMap[_vm.form.createdBy.user].name) +
                          " Kullanıcısı bu görevi\n                        " +
                          _vm._s(_vm.formattedCreatedAt) +
                          " tarihinde oluşturdu"
                      ),
                    ]),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.form.createdBy.type === "api"
          ? _c(
              "div",
              {
                staticClass: "info-task-item",
                staticStyle: { display: "block" },
              },
              [
                _c("label", [
                  _vm._v(" " + _vm._s(_vm.$t("message.taskCreator")) + " "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "create-task-avatar-message" },
                  [
                    _c("Avatar", {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                        }",
                        },
                      ],
                      key: 1,
                      attrs: {
                        size: 25,
                        src: "https://static.supsis.live/common/email/supsisyazisislogo.png",
                        username: "Chatbot",
                        content: null,
                      },
                    }),
                    _vm._v(" "),
                    _c("label", [
                      _vm._v(
                        "Chatbot bu görevi " +
                          _vm._s(_vm.formattedCreatedAt) +
                          " tarihinde oluşturdu"
                      ),
                    ]),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "info-task-item", staticStyle: { display: "block" } },
          [
            _c("label", [_vm._v("İlgili Ziyaretçi")]),
            _vm._v(" "),
            _vm.visitorRelation
              ? _c("div", { staticClass: "task-avatar-message" }, [
                  _c(
                    "div",
                    {
                      staticClass: "visitor-info",
                      on: { click: _vm.visitorDetail },
                    },
                    [
                      _c("Avatar", {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                            }",
                          },
                        ],
                        attrs: {
                          size: 25,
                          src: _vm.visitorRelation.visitor.gravatar,
                          username: _vm.visitorRelation.visitor.fullname,
                          content: _vm.visitorRelation.visitor.fullname,
                        },
                      }),
                      _vm._v(" "),
                      _c("label", [
                        _vm._v(_vm._s(_vm.visitorRelation.visitor.fullname)),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "delete-icon",
                      on: { click: _vm.removeVisitor },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("close"),
                      ]),
                    ]
                  ),
                ])
              : _c(
                  "div",
                  { staticClass: "add-visitor", on: { click: _vm.addVisitor } },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("add"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Ziyaretçi Ekle")]),
                  ]
                ),
            _vm._v(" "),
            _vm.showModal
              ? _c(
                  "Modal2",
                  {
                    attrs: {
                      title: "Kişi Seç",
                      okText: "Kaydet",
                      xlarge: "",
                      className: "contact-picker-modal keydown-prevent-modal",
                    },
                    on: { cancel: _vm.closeModal },
                  },
                  [
                    _c("List", {
                      attrs: { "picker-mode": "" },
                      on: { select: _vm.handleVisitorSelect },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.getUserIds(_vm.form).length > 0
          ? _c(
              "div",
              {
                staticClass: "info-task-item",
                staticStyle: { display: "block" },
              },
              [
                _c("label", [_vm._v(_vm._s(_vm.$t("task.assignees")))]),
                _vm._v(" "),
                _vm._l(_vm.getUserIds(_vm.form), function (userId) {
                  return _c(
                    "div",
                    { key: userId, staticClass: "task-avatar-message" },
                    [
                      _c("Avatar", {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                        }",
                          },
                        ],
                        key: 1,
                        attrs: {
                          size: 25,
                          src:
                            _vm.usersMap[userId] &&
                            _vm.usersMap[userId].gravatar,
                          username:
                            _vm.usersMap[userId] && _vm.usersMap[userId].name,
                          content:
                            _vm.usersMap[userId] && _vm.usersMap[userId].email,
                        },
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v(_vm._s(_vm.usersMap[userId].name))]),
                      _vm._v(" "),
                      userId._id !== _vm.loggedUser._id
                        ? _c(
                            "div",
                            {
                              staticClass: "msg-icon",
                              on: {
                                click: function ($event) {
                                  return _vm.startDM(_vm.usersMap[userId]._id)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "md-icon" }, [
                                _vm._v("contact_mail"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                }),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.getUserIdsOwner(_vm.form).length > 0
          ? _c(
              "div",
              {
                staticClass: "info-task-item",
                staticStyle: { display: "block" },
              },
              [
                _c("label", [_vm._v(_vm._s(_vm.$t("task.owner")))]),
                _vm._v(" "),
                _vm._l(_vm.getUserIdsOwner(_vm.form), function (userId) {
                  return _c(
                    "div",
                    { key: userId, staticClass: "task-avatar-message" },
                    [
                      _c("Avatar", {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                        }",
                          },
                        ],
                        key: 1,
                        attrs: {
                          size: 25,
                          src:
                            _vm.usersMap[userId] &&
                            _vm.usersMap[userId].gravatar,
                          username:
                            _vm.usersMap[userId] && _vm.usersMap[userId].name,
                          content:
                            _vm.usersMap[userId] && _vm.usersMap[userId].email,
                        },
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v(_vm._s(_vm.usersMap[userId].name))]),
                      _vm._v(" "),
                      userId._id !== _vm.loggedUser._id
                        ? _c(
                            "div",
                            {
                              staticClass: "msg-icon",
                              on: {
                                click: function ($event) {
                                  return _vm.startDM(_vm.usersMap[userId]._id)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "md-icon" }, [
                                _vm._v("contact_mail"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                }),
              ],
              2
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "file-icon" }, [
      _c("span", { staticClass: "md-icon" }, [_vm._v("insert_drive_file")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }